
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/itsm-change-management",
      function () {
        return require("private-next-pages/solutions/itsm-change-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/itsm-change-management"])
      });
    }
  